import { Attribution, SortBy, SortType } from 'types'

interface TableDataParams {
  attr: Attribution
  endDate: string
  startDate: string
  limit: number
  offset: number
  sortBy?: SortBy
  sortType?: SortType
}

function getSortClause(
  sortBy: SortBy | undefined,
  sortType: SortType | undefined,
  attr: Attribution
): string {
  if (!sortBy || !sortType) return ''
  let field: string
  if (sortBy === 'views') {
    field = `stats.views`
  } else if (attr === 'first' || attr === 'last') {
    field = `${attr}.${sortBy}`
  } else {
    field = `${attr}_source.${sortBy}`
  }
  return `ORDER BY ${field} ${sortType}`
}

export const getAllChannelsTableData = ({
  endDate,
  startDate,
  limit,
  offset,
  attr,
  sortBy,
  sortType,
}: TableDataParams) => {
  const sorting = getSortClause(sortBy, sortType, attr)
  switch (attr) {
    case 'first':
      return `SELECT stats.channel_id, SUM(stats.views), SUM(stats.new_visitors), SUM(first.new_customers), SUM(first.leads), SUM(first.form_submits), SUM(first.total_orders), SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount), SUM(first.ad_spend), channel.icon, channel.name, channel.__typename FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.channel_id, channel.icon, channel.name, channel.__typename ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'last':
      return `SELECT stats.channel_id, SUM(stats.views), SUM(stats.new_visitors), SUM(last.new_customers), SUM(last.leads), SUM(last.form_submits), SUM(last.total_orders), SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount), SUM(last.ad_spend), channel.icon, channel.name, channel.__typename FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.channel_id, channel.icon, channel.name, channel.__typename ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'linear':
      return `SELECT stats.channel_id, SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(linear_source.leads), SUM(linear_source.form_submits), SUM(linear_source.total_orders), SUM(linear_source.total_amount), SUM(linear_source.recurring_payments_amount), SUM(linear_source.orders_amount), SUM(linear_source.ad_spend), channel.icon, channel.name, channel.__typename FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.channel_id, channel.icon, channel.name, channel.__typename ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'ai':
      return `SELECT stats.channel_id, SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(ai_source.leads), SUM(ai_source.form_submits), SUM(ai_source.total_orders), SUM(ai_source.total_amount), SUM(ai_source.recurring_payments_amount), SUM(ai_source.orders_amount), SUM(ai_source.ad_spend), channel.icon, channel.name, channel.__typename FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.channel_id, channel.icon, channel.name, channel.__typename ${sorting} LIMIT ${limit} OFFSET ${offset}`
    default:
      return ''
  }
}
